import * as React from 'react';
import PropTypes from 'prop-types';
import { Typography, Tabs, Tab, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { resetFilterDataState } from '../../modules/filter/filterAction';
import { RESET_DATE_RANGE } from '../../constants';
import { cardComponentCollapse } from '../../modules/cardState/cardAction';

export function TabsBody(props) {
  const { children, value, index, isEmp, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, paddingTop: isEmp ? 3 : 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabsBody.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function DynamicTabsComponent(props) {
  const { activeTab, TabsList, setActiveTab, isEmp } = props;

  const dispatch = useDispatch();

  //   React.useEffect(()=>{
  // if (!activeTab){
  //   activeTab = TabsList[0];
  // }
  //   },[])
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    dispatch(resetFilterDataState());
    dispatch({
      type: RESET_DATE_RANGE,
    });
    dispatch(cardComponentCollapse());
  };

  return (
    <Box>
      <Tabs
        value={activeTab || 0}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {TabsList.map((tab, index) => (
          <Tab label={tab.title} {...a11yProps(index)} key={tab.title} />
        ))}
      </Tabs>
      {TabsList.map((tab, index) => (
        <TabsBody
          value={activeTab || 0}
          index={index}
          key={index}
          isEmp={isEmp}
        >
          {tab.component}
        </TabsBody>
      ))}
    </Box>
  );
}
